/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { ENotificationUpdateStatus } from '../constants';
import { INotificationsEntity, INotificationsItem } from '../types';

export const getUnreadNotificationsCount = (items?: INotificationsItem[]): number => {
    if (!items || !items.length) return 0;

    return items.filter((el) => !el.viewed).length;
};

export const convertBoolToNotificationStatus = (isViewed: boolean): ENotificationUpdateStatus => {
    return isViewed ? ENotificationUpdateStatus.VIEWED : ENotificationUpdateStatus.UNVIEWED;
};

export const getNotificationContent = (entity: INotificationsEntity) => entity.def || '';

// обрезаем html-теги с помощью регулярки, т.к. Notification API не поддерживает html
export const getNotificationApiTitle = (entity: INotificationsEntity) =>
    getNotificationContent(entity).replace(/(<([^>]+)>)/gi, '');
